// removed by extract-text-webpack-plugin
module.exports = {"item":"_2a6Fygd3pscep1Pj1G_pKs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/item/item.css
// module id = 37
// module chunks = 0